import { render, staticRenderFns } from "./DemoSort.vue?vue&type=template&id=73e004e8&scoped=true"
import script from "./DemoSort.vue?vue&type=script&lang=ts"
export * from "./DemoSort.vue?vue&type=script&lang=ts"
import style0 from "./DemoSort.vue?vue&type=style&index=0&id=73e004e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e004e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
